const districtData = {
  info:
[{
  District: 'Alameda Unified',
  County: 'Alameda',
  BEnr9091: 967,
  TotalEnr9091: 8895,
  BEnr2021: 715,
  TotalEnr2021: 10927,
  BEnr9091Perc: 0.10871275997751546,
  BEnr2021Perc: 0.06543424544705774,
  diff: '-4.33%',
  color: '#fab081',
  size: 8,
  center: [37.76333764882534, -122.26587117129979],
},
{
  District: 'Albany City Unified',
  County: 'Alameda',
  BEnr9091: 324,
  TotalEnr9091: 2646,
  BEnr2021: 118,
  TotalEnr2021: 3501,
  BEnr9091Perc: 0.12244897959183673,
  BEnr2021Perc: 0.03370465581262497,
  diff: '-8.87%',
  color: '#f6975f',
  size: 8,
  center: [37.889900732600715, -122.29889912850467],
},
{
  District: 'Berkeley Unified',
  County: 'Alameda',
  BEnr9091: 3477,
  TotalEnr9091: 7895,
  BEnr2021: 1193,
  TotalEnr2021: 9409,
  BEnr9091Perc: 0.44040531982267256,
  BEnr2021Perc: 0.12679349558932937,
  diff: '-31.36%',
  color: '#b5663b',
  size: 8,
  center: [37.87245059405187, -122.27471883963752],
},
{
  District: 'Castro Valley Unified',
  County: 'Alameda',
  BEnr9091: 181,
  TotalEnr9091: 6120,
  BEnr2021: 451,
  TotalEnr2021: 9203,
  BEnr9091Perc: 0.02957516339869281,
  BEnr2021Perc: 0.04900575899163316,
  diff: '1.94%',
  color: '#fbc9a6',
  size: 6,
  center: [37.72481910040385, -122.04417927182296],
},
{
  District: 'Emery Unified',
  County: 'Alameda',
  BEnr9091: 388,
  TotalEnr9091: 576,
  BEnr2021: 315,
  TotalEnr2021: 698,
  BEnr9091Perc: 0.6736111111111112,
  BEnr2021Perc: 0.4512893982808023,
  diff: '-22.23%',
  color: '#f3803f',
  size: 6,
  center: [37.83791910786704, -122.29068404429601],
},
{
  District: 'Fremont Unified',
  County: 'Alameda',
  BEnr9091: 1112,
  TotalEnr9091: 27172,
  BEnr2021: 622,
  TotalEnr2021: 35187,
  BEnr9091Perc: 0.04092448108346828,
  BEnr2021Perc: 0.01767698297666752,
  diff: '-2.32%',
  color: '#fab081',
  size: 8,
  center: [37.52748285247377, -121.98257937692699],
},
{
  District: 'Hayward Unified',
  County: 'Alameda',
  BEnr9091: 2819,
  TotalEnr9091: 19122,
  BEnr2021: 1679,
  TotalEnr2021: 21638,
  BEnr9091Perc: 0.1474218178014852,
  BEnr2021Perc: 0.07759497180885479,
  diff: '-6.98%',
  color: '#fab081',
  size: 8,
  center: [37.64400556661094, -122.07880499614076],
},
{
  District: 'Livermore Valley Joint Unified',
  County: 'Alameda',
  BEnr9091: 243,
  TotalEnr9091: 10462,
  BEnr2021: 156,
  TotalEnr2021: 13305,
  BEnr9091Perc: 0.02322691645956796,
  BEnr2021Perc: 0.011724915445321308,
  diff: '-1.15%',
  color: '#fab081',
  size: 6,
  center: [37.646401490730206, -121.68484696833109],
},
{
  District: 'Mountain House Elementary',
  County: 'Alameda',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.742076269482276, -121.58460934366315],
},
{
  District: 'Newark Unified',
  County: 'Alameda',
  BEnr9091: 372,
  TotalEnr9091: 6928,
  BEnr2021: 157,
  TotalEnr2021: 5507,
  BEnr9091Perc: 0.05369515011547344,
  BEnr2021Perc: 0.028509170147085528,
  diff: '-2.52%',
  color: '#fab081',
  size: 8,
  center: [37.52009290353794, -122.03065454379521],
},
{
  District: 'New Haven Unified',
  County: 'Alameda',
  BEnr9091: 1304,
  TotalEnr9091: 12070,
  BEnr2021: 496,
  TotalEnr2021: 10812,
  BEnr9091Perc: 0.10803645401822701,
  BEnr2021Perc: 0.04587495375508694,
  diff: '-6.22%',
  color: '#fab081',
  size: 8,
  center: [37.598562379362534, -122.04514519458094],
},
{
  District: 'Oakland Unified',
  County: 'Alameda',
  BEnr9091: 29327,
  TotalEnr9091: 52095,
  BEnr2021: 10551,
  TotalEnr2021: 48704,
  BEnr9091Perc: 0.5629522986850946,
  BEnr2021Perc: 0.21663518396846254,
  diff: '-34.63%',
  color: '#b5663b',
  size: 16,
  center: [37.79448404605824, -122.21508887095948],
},
{
  District: 'Piedmont City Unified',
  County: 'Alameda',
  BEnr9091: 36,
  TotalEnr9091: 2204,
  BEnr2021: 38,
  TotalEnr2021: 2464,
  BEnr9091Perc: 0.016333938294010888,
  BEnr2021Perc: 0.015422077922077922,
  diff: '-0.09%',
  color: '#fab081',
  size: 6,
  center: [37.82256738213073, -122.23002431076608],
},
{
  District: 'San Leandro Unified',
  County: 'Alameda',
  BEnr9091: 782,
  TotalEnr9091: 6551,
  BEnr2021: 1035,
  TotalEnr2021: 8828,
  BEnr9091Perc: 0.11937108838345291,
  BEnr2021Perc: 0.1172405980969642,
  diff: '-0.21%',
  color: '#fab081',
  size: 6,
  center: [37.71146499660917, -122.16571403994386],
},
{
  District: 'San Lorenzo Unified',
  County: 'Alameda',
  BEnr9091: 714,
  TotalEnr9091: 8500,
  BEnr2021: 862,
  TotalEnr2021: 10528,
  BEnr9091Perc: 0.084,
  BEnr2021Perc: 0.08187689969604864,
  diff: '-0.21%',
  color: '#fab081',
  size: 6,
  center: [37.678786129389735, -122.13130185409136],
},
{
  District: 'Dublin Unified',
  County: 'Alameda',
  BEnr9091: 108,
  TotalEnr9091: 3163,
  BEnr2021: 362,
  TotalEnr2021: 12625,
  BEnr9091Perc: 0.03414479924122668,
  BEnr2021Perc: 0.028673267326732674,
  diff: '-0.55%',
  color: '#fab081',
  size: 6,
  center: [37.71644666035747, -121.90051364359171],
},
{
  District: 'Pleasanton Unified',
  County: 'Alameda',
  BEnr9091: 147,
  TotalEnr9091: 9039,
  BEnr2021: 205,
  TotalEnr2021: 14469,
  BEnr9091Perc: 0.016262860935944243,
  BEnr2021Perc: 0.014168221715391527,
  diff: '-0.21%',
  color: '#fab081',
  size: 6,
  center: [37.66216570121163, -121.88747659817844],
},
{
  District: 'Sunol Glen Unified',
  County: 'Alameda',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.55511504137836, -121.82205378224593],
},
{
  District: 'Acalanes Union High',
  County: 'Contra Costa',
  BEnr9091: 39,
  TotalEnr9091: 3921,
  BEnr2021: 89,
  TotalEnr2021: 5535,
  BEnr9091Perc: 0.009946442234123947,
  BEnr2021Perc: 0.016079494128274616,
  diff: '0.61%',
  color: '#fab081',
  size: 6,
  center: [37.8758667077703, -122.1319483514607],
},
{
  District: 'Antioch Unified',
  County: 'Contra Costa',
  BEnr9091: 406,
  TotalEnr9091: 13045,
  BEnr2021: 4043,
  TotalEnr2021: 16599,
  BEnr9091Perc: 0.031123035645841318,
  BEnr2021Perc: 0.24356888969215013,
  diff: '21.24%',
  color: '#fee2cd',
  size: 6,
  center: [37.9788477792132, -121.80584146999179],
},
{
  District: 'Brentwood Union Elementary',
  County: 'Contra Costa',
  BEnr9091: 12,
  TotalEnr9091: 1917,
  BEnr2021: 656,
  TotalEnr2021: 9023,
  BEnr9091Perc: 0.006259780907668232,
  BEnr2021Perc: 0.07270309209797185,
  diff: '6.64%',
  color: '#fbc9a6',
  size: 6,
  center: [37.90706107854947, -121.74846467517163],
},
{
  District: 'Byron Union Elementary',
  County: 'Contra Costa',
  BEnr9091: 5,
  TotalEnr9091: 714,
  BEnr2021: 124,
  TotalEnr2021: 2193,
  BEnr9091Perc: 0.0070028011204481795,
  BEnr2021Perc: 0.056543547651618786,
  diff: '4.95%',
  color: '#fbc9a6',
  size: 6,
  center: [37.84713364075789, -121.65288874170125],
},
{
  District: 'Canyon Elementary',
  County: 'Contra Costa',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.830051141810735, -122.17076445077534],
},
{
  District: 'John Swett Unified',
  County: 'Contra Costa',
  BEnr9091: 280,
  TotalEnr9091: 2052,
  BEnr2021: 192,
  TotalEnr2021: 1312,
  BEnr9091Perc: 0.1364522417153996,
  BEnr2021Perc: 0.14634146341463414,
  diff: '0.99%',
  color: '#fab081',
  size: 6,
  center: [38.02380778984544, -122.21572066182792],
},
{
  District: 'Knightsen Elementary',
  County: 'Contra Costa',
  BEnr9091: 3,
  TotalEnr9091: 248,
  BEnr2021: 8,
  TotalEnr2021: 608,
  BEnr9091Perc: 0.012096774193548387,
  BEnr2021Perc: 0.013157894736842105,
  diff: '0.11%',
  color: '#fab081',
  size: 6,
  center: [37.962276667718264, -121.61606799690993],
},
{
  District: 'Lafayette Elementary',
  County: 'Contra Costa',
  BEnr9091: 21,
  TotalEnr9091: 2817,
  BEnr2021: 23,
  TotalEnr2021: 3261,
  BEnr9091Perc: 0.007454739084132056,
  BEnr2021Perc: 0.007053051211284882,
  diff: '-0.04%',
  color: '#fab081',
  size: 6,
  center: [37.897230629170856, -122.115587388483],
},
{
  District: 'Liberty Union High',
  County: 'Contra Costa',
  BEnr9091: 21,
  TotalEnr9091: 1767,
  BEnr2021: 704,
  TotalEnr2021: 8222,
  BEnr9091Perc: 0.011884550084889643,
  BEnr2021Perc: 0.08562393578204816,
  diff: '7.37%',
  color: '#fbc9a6',
  size: 6,
  center: [37.923618596098414, -121.6722899468289],
},
{
  District: 'Martinez Unified',
  County: 'Contra Costa',
  BEnr9091: 123,
  TotalEnr9091: 3415,
  BEnr2021: 102,
  TotalEnr2021: 3983,
  BEnr9091Perc: 0.03601756954612006,
  BEnr2021Perc: 0.025608837559628422,
  diff: '-1.04%',
  color: '#fab081',
  size: 6,
  center: [37.980947633351676, -122.14994116666989],
},
{
  District: 'Moraga Elementary',
  County: 'Contra Costa',
  BEnr9091: 11,
  TotalEnr9091: 1595,
  BEnr2021: 19,
  TotalEnr2021: 1769,
  BEnr9091Perc: 0.006896551724137931,
  BEnr2021Perc: 0.010740531373657434,
  diff: '0.38%',
  color: '#fab081',
  size: 6,
  center: [37.831608529265075, -122.10885681469527],
},
{
  District: 'Mt. Diablo Unified',
  County: 'Contra Costa',
  BEnr9091: 1174,
  TotalEnr9091: 32840,
  BEnr2021: 916,
  TotalEnr2021: 29908,
  BEnr9091Perc: 0.035749086479902555,
  BEnr2021Perc: 0.03062725692122509,
  diff: '-0.51%',
  color: '#fab081',
  size: 8,
  center: [37.95682205428304, -121.9767882685216],
},
{
  District: 'Oakley Union Elementary',
  County: 'Contra Costa',
  BEnr9091: 47,
  TotalEnr9091: 2884,
  BEnr2021: 516,
  TotalEnr2021: 4939,
  BEnr9091Perc: 0.016296809986130374,
  BEnr2021Perc: 0.10447458999797529,
  diff: '8.82%',
  color: '#fbc9a6',
  size: 6,
  center: [38.03366164956688, -121.652284371883],
},
{
  District: 'Orinda Union Elementary',
  County: 'Contra Costa',
  BEnr9091: 25,
  TotalEnr9091: 1935,
  BEnr2021: 31,
  TotalEnr2021: 2478,
  BEnr9091Perc: 0.012919896640826873,
  BEnr2021Perc: 0.012510088781275222,
  diff: '-0.04%',
  color: '#fab081',
  size: 6,
  center: [37.889946849571714, -122.19528379261928],
},
{
  District: 'Pittsburg Unified',
  County: 'Contra Costa',
  BEnr9091: 2108,
  TotalEnr9091: 8166,
  BEnr2021: 1737,
  TotalEnr2021: 11015,
  BEnr9091Perc: 0.25814352192015677,
  BEnr2021Perc: 0.15769405356332275,
  diff: '-10.04%',
  color: '#f6975f',
  size: 8,
  center: [38.00240787394399, -121.8890284409961],
},
{
  District: 'West Contra Costa Unified',
  County: 'Contra Costa',
  BEnr9091: 11068,
  TotalEnr9091: 31292,
  BEnr2021: 4155,
  TotalEnr2021: 31027,
  BEnr9091Perc: 0.3537006263581746,
  BEnr2021Perc: 0.1339156218777194,
  diff: '-21.98%',
  color: '#f3803f',
  size: 10,
  center: [37.95677730697509, -122.30980696483236],
},
{
  District: 'San Ramon Valley Unified',
  County: 'Contra Costa',
  BEnr9091: 263,
  TotalEnr9091: 16119,
  BEnr2021: 512,
  TotalEnr2021: 30726,
  BEnr9091Perc: 0.01631614864445685,
  BEnr2021Perc: 0.01666341209399206,
  diff: '0.03%',
  color: '#fab081',
  size: 6,
  center: [37.805300568236916, -121.9409774180977],
},
{
  District: 'Walnut Creek Elementary',
  County: 'Contra Costa',
  BEnr9091: 40,
  TotalEnr9091: 2784,
  BEnr2021: 87,
  TotalEnr2021: 3467,
  BEnr9091Perc: 0.014367816091954023,
  BEnr2021Perc: 0.02509374098644361,
  diff: '1.07%',
  color: '#fab081',
  size: 6,
  center: [37.88740327389466, -122.05389094667487],
},
{
  District: 'Kelseyville Unified',
  County: 'Lake',
  BEnr9091: 16,
  TotalEnr9091: 1893,
  BEnr2021: 10,
  TotalEnr2021: 1745,
  BEnr9091Perc: 0.008452192287374538,
  BEnr2021Perc: 0.0057306590257879654,
  diff: '-0.27%',
  color: '#fab081',
  size: 6,
  center: [38.94021428440914, -122.80715235006033],
},
{
  District: 'Konocti Unified',
  County: 'Lake',
  BEnr9091: 145,
  TotalEnr9091: 3165,
  BEnr2021: 85,
  TotalEnr2021: 3603,
  BEnr9091Perc: 0.045813586097946286,
  BEnr2021Perc: 0.023591451568137665,
  diff: '-2.22%',
  color: '#fab081',
  size: 6,
  center: [38.96385722295835, -122.56690262439487],
},
{
  District: 'Lakeport Unified',
  County: 'Lake',
  BEnr9091: 19,
  TotalEnr9091: 1588,
  BEnr2021: 19,
  TotalEnr2021: 1388,
  BEnr9091Perc: 0.011964735516372796,
  BEnr2021Perc: 0.013688760806916427,
  diff: '0.17%',
  color: '#fab081',
  size: 6,
  center: [39.05783333068395, -122.96819218005015],
},
{
  District: 'Lucerne Elementary',
  County: 'Lake',
  BEnr9091: 5,
  TotalEnr9091: 294,
  BEnr2021: 6,
  TotalEnr2021: 274,
  BEnr9091Perc: 0.017006802721088437,
  BEnr2021Perc: 0.021897810218978103,
  diff: '0.49%',
  color: '#fab081',
  size: 6,
  center: [39.09017782491195, -122.78581271041861],
},
{
  District: 'Middletown Unified',
  County: 'Lake',
  BEnr9091: 9,
  TotalEnr9091: 1314,
  BEnr2021: 10,
  TotalEnr2021: 1655,
  BEnr9091Perc: 0.00684931506849315,
  BEnr2021Perc: 0.006042296072507553,
  diff: '-0.08%',
  color: '#fab081',
  size: 6,
  center: [38.768745873012584, -122.60535853802638],
},
{
  District: 'Upper Lake Unified',
  County: 'Lake',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [39.30092055727097, -122.83592810729833],
},
{
  District: 'Bolinas-Stinson Union',
  County: 'Marin',
  BEnr9091: 1,
  TotalEnr9091: 233,
  BEnr2021: 2,
  TotalEnr2021: 84,
  BEnr9091Perc: 0.004291845493562232,
  BEnr2021Perc: 0.023809523809523808,
  diff: '1.95%',
  color: '#fbc9a6',
  size: 6,
  center: [37.9419067876577, -122.70675386019839],
},
{
  District: 'Dixie Elementary',
  County: 'Marin',
  BEnr9091: 24,
  TotalEnr9091: 1416,
  BEnr2021: 24,
  TotalEnr2021: 1860,
  BEnr9091Perc: 0.01694915254237288,
  BEnr2021Perc: 0.012903225806451613,
  diff: '-0.4%',
  color: '#fab081',
  size: 6,
  center: [38.03130675833649, -122.57225533685207],
},
{
  District: 'Kentfield Elementary',
  County: 'Marin',
  BEnr9091: 1,
  TotalEnr9091: 865,
  BEnr2021: 9,
  TotalEnr2021: 1097,
  BEnr9091Perc: 0.0011560693641618498,
  BEnr2021Perc: 0.008204193254329991,
  diff: '0.7%',
  color: '#fab081',
  size: 6,
  center: [37.95141307181809, -122.61452201632873],
},
{
  District: 'Laguna Joint Elementary',
  County: 'Marin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.18800945358825, -122.77399014172944],
},
{
  District: 'Lagunitas Elementary',
  County: 'Marin',
  BEnr9091: 9,
  TotalEnr9091: 358,
  BEnr2021: 2,
  TotalEnr2021: 229,
  BEnr9091Perc: 0.025139664804469275,
  BEnr2021Perc: 0.008733624454148471,
  diff: '-1.64%',
  color: '#fab081',
  size: 6,
  center: [38.00414404893697, -122.67362478852074],
},
{
  District: 'Larkspur-Corte Madera',
  County: 'Marin',
  BEnr9091: 18,
  TotalEnr9091: 777,
  BEnr2021: 5,
  TotalEnr2021: 1434,
  BEnr9091Perc: 0.023166023166023165,
  BEnr2021Perc: 0.003486750348675035,
  diff: '-1.97%',
  color: '#fab081',
  size: 6,
  center: [37.929300820806084, -122.52672867435363],
},
{
  District: 'Lincoln Elementary',
  County: 'Marin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.14692748862243, -122.69089263870019],
},
{
  District: 'Mill Valley Elementary',
  County: 'Marin',
  BEnr9091: 76,
  TotalEnr9091: 1766,
  BEnr2021: 13,
  TotalEnr2021: 2640,
  BEnr9091Perc: 0.04303510758776897,
  BEnr2021Perc: 0.004924242424242424,
  diff: '-3.81%',
  color: '#fab081',
  size: 6,
  center: [37.89540207548142, -122.55984908576406],
},
{
  District: 'Nicasio',
  County: 'Marin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.07831264419367, -122.70238154342778],
},
{
  District: 'Novato Unified',
  County: 'Marin',
  BEnr9091: 279,
  TotalEnr9091: 7943,
  BEnr2021: 173,
  TotalEnr2021: 7476,
  BEnr9091Perc: 0.035125267531159514,
  BEnr2021Perc: 0.02314071696094168,
  diff: '-1.2%',
  color: '#fab081',
  size: 8,
  center: [38.10734060841502, -122.56666634761866],
},
{
  District: 'Reed Union Elementary',
  County: 'Marin',
  BEnr9091: 23,
  TotalEnr9091: 825,
  BEnr2021: 7,
  TotalEnr2021: 1205,
  BEnr9091Perc: 0.027878787878787878,
  BEnr2021Perc: 0.005809128630705394,
  diff: '-2.21%',
  color: '#fab081',
  size: 6,
  center: [37.88927791544928, -122.46709547937272],
},
{
  District: 'Ross Elementary',
  County: 'Marin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.96285192620383, -122.56794875677667],
},
{
  District: 'San Rafael City Elementary',
  County: 'Marin',
  BEnr9091: 207,
  TotalEnr9091: 2765,
  BEnr2021: 35,
  TotalEnr2021: 4415,
  BEnr9091Perc: 0.07486437613019892,
  BEnr2021Perc: 0.007927519818799546,
  diff: '-6.69%',
  color: '#fab081',
  size: 8,
  center: [37.98340231822946, -122.5058377235735],
},
{
  District: 'San Rafael City High',
  County: 'Marin',
  BEnr9091: 86,
  TotalEnr9091: 1612,
  BEnr2021: 34,
  TotalEnr2021: 2666,
  BEnr9091Perc: 0.05334987593052109,
  BEnr2021Perc: 0.012753188297074268,
  diff: '-4.06%',
  color: '#fab081',
  size: 6,
  center: [38.00811016691515, -122.54009417945267],
},
{
  District: 'Sausalito Marin City',
  County: 'Marin',
  BEnr9091: 156,
  TotalEnr9091: 371,
  BEnr2021: 100,
  TotalEnr2021: 457,
  BEnr9091Perc: 0.42048517520215634,
  BEnr2021Perc: 0.2188183807439825,
  diff: '-20.17%',
  color: '#f3803f',
  size: 6,
  center: [37.848070099767114, -122.51515602347479],
},
{
  District: 'Tamalpais Union High',
  County: 'Marin',
  BEnr9091: 139,
  TotalEnr9091: 2757,
  BEnr2021: 98,
  TotalEnr2021: 5166,
  BEnr9091Perc: 0.050417120058034094,
  BEnr2021Perc: 0.018970189701897018,
  diff: '-3.14%',
  color: '#fab081',
  size: 6,
  center: [37.96615385953026, -122.6342917293108],
},
{
  District: 'Shoreline Unified',
  County: 'Marin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.18026824160645, -122.89493984385928],
},
{
  District: 'Ross Valley Elementary',
  County: 'Marin',
  BEnr9091: 34,
  TotalEnr9091: 1579,
  BEnr2021: 19,
  TotalEnr2021: 1764,
  BEnr9091Perc: 0.021532615579480684,
  BEnr2021Perc: 0.010770975056689343,
  diff: '-1.08%',
  color: '#fab081',
  size: 6,
  center: [37.99371963553161, -122.59277678737341],
},
{
  District: 'Anderson Valley Unified',
  County: 'Mendocino',
  BEnr9091: 6,
  TotalEnr9091: 603,
  BEnr2021: 3,
  TotalEnr2021: 434,
  BEnr9091Perc: 0.009950248756218905,
  BEnr2021Perc: 0.0069124423963133645,
  diff: '-0.3%',
  color: '#fab081',
  size: 6,
  center: [38.987970057109955, -123.35619186664536],
},
{
  District: 'Arena Union Elementary',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.86360582246759, -123.529100648125],
},
{
  District: 'Fort Bragg Unified',
  County: 'Mendocino',
  BEnr9091: 13,
  TotalEnr9091: 2487,
  BEnr2021: 8,
  TotalEnr2021: 1779,
  BEnr9091Perc: 0.005227181342983514,
  BEnr2021Perc: 0.004496908375491849,
  diff: '-0.07%',
  color: '#fab081',
  size: 6,
  center: [39.531482214388696, -123.69045548202065],
},
{
  District: 'Manchester Union Elementary',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.99483423370264, -123.59777672546856],
},
{
  District: 'Mendocino Unified',
  County: 'Mendocino',
  BEnr9091: 8,
  TotalEnr9091: 898,
  BEnr2021: 9,
  TotalEnr2021: 477,
  BEnr9091Perc: 0.008908685968819599,
  BEnr2021Perc: 0.018867924528301886,
  diff: '1.0%',
  color: '#fab081',
  size: 6,
  center: [39.24867155673226, -123.61072815591932],
},
{
  District: 'Point Arena Joint Union High',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.83901610615469, -123.46935994281478],
},
{
  District: 'Round Valley Unified',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [39.76662987333097, -123.15018647689453],
},
{
  District: 'Ukiah Unified',
  County: 'Mendocino',
  BEnr9091: 82,
  TotalEnr9091: 6648,
  BEnr2021: 41,
  TotalEnr2021: 6499,
  BEnr9091Perc: 0.01233453670276775,
  BEnr2021Perc: 0.006308662871210955,
  diff: '-0.6%',
  color: '#fab081',
  size: 6,
  center: [39.11139207771988, -123.19404745999162],
},
{
  District: 'Willits Unified',
  County: 'Mendocino',
  BEnr9091: 19,
  TotalEnr9091: 2526,
  BEnr2021: 16,
  TotalEnr2021: 1868,
  BEnr9091Perc: 0.007521773555027712,
  BEnr2021Perc: 0.008565310492505354,
  diff: '0.1%',
  color: '#fab081',
  size: 6,
  center: [39.47126353486417, -123.35508417845453],
},
{
  District: 'Potter Valley Community Unified',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [39.33997628233481, -123.10432585263376],
},
{
  District: 'Laytonville Unified',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [39.76381371750642, -123.52755719045327],
},
{
  District: 'Leggett Valley Unified',
  County: 'Mendocino',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [39.860575478141, -123.7564251949155],
},
{
  District: 'Atwater Elementary',
  County: 'Merced',
  BEnr9091: 412,
  TotalEnr9091: 4506,
  BEnr2021: 106,
  TotalEnr2021: 4815,
  BEnr9091Perc: 0.09143364403018198,
  BEnr2021Perc: 0.02201453790238837,
  diff: '-6.94%',
  color: '#fab081',
  size: 8,
  center: [37.36290774887161, -120.61235078802268],
},
{
  District: 'Ballico-Cressey Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.47058171116511, -120.66883472923271],
},
{
  District: 'El Nido Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.13603142125897, -120.50190008084704],
},
{
  District: 'Hilmar Unified',
  County: 'Merced',
  BEnr9091: 24,
  TotalEnr9091: 1942,
  BEnr2021: 7,
  TotalEnr2021: 2350,
  BEnr9091Perc: 0.012358393408856848,
  BEnr2021Perc: 0.0029787234042553193,
  diff: '-0.94%',
  color: '#fab081',
  size: 6,
  center: [37.34491586058517, -120.85376227085536],
},
{
  District: 'Le Grand Union Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.21585029123189, -120.20084288428318],
},
{
  District: 'Le Grand Union High',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.235900200550304, -120.26140226557429],
},
{
  District: 'Livingston Union',
  County: 'Merced',
  BEnr9091: 17,
  TotalEnr9091: 1832,
  BEnr2021: 18,
  TotalEnr2021: 2474,
  BEnr9091Perc: 0.009279475982532752,
  BEnr2021Perc: 0.007275666936135812,
  diff: '-0.2%',
  color: '#fab081',
  size: 6,
  center: [37.35895600076944, -120.74260343898743],
},
{
  District: 'Los Banos Unified',
  County: 'Merced',
  BEnr9091: 132,
  TotalEnr9091: 4008,
  BEnr2021: 161,
  TotalEnr2021: 10858,
  BEnr9091Perc: 0.03293413173652695,
  BEnr2021Perc: 0.014827776754466752,
  diff: '-1.81%',
  color: '#fab081',
  size: 6,
  center: [36.99423386383229, -120.92900218960179],
},
{
  District: 'McSwain Union Elementary',
  County: 'Merced',
  BEnr9091: 2,
  TotalEnr9091: 712,
  BEnr2021: 3,
  TotalEnr2021: 839,
  BEnr9091Perc: 0.0028089887640449437,
  BEnr2021Perc: 0.003575685339690107,
  diff: '0.08%',
  color: '#fab081',
  size: 6,
  center: [37.24660813269958, -120.63138941050747],
},
{
  District: 'Merced City Elementary',
  County: 'Merced',
  BEnr9091: 744,
  TotalEnr9091: 11040,
  BEnr2021: 505,
  TotalEnr2021: 10800,
  BEnr9091Perc: 0.06739130434782609,
  BEnr2021Perc: 0.04675925925925926,
  diff: '-2.06%',
  color: '#fab081',
  size: 8,
  center: [37.36934518004365, -120.44524607897122],
},
{
  District: 'Merced Union High',
  County: 'Merced',
  BEnr9091: 435,
  TotalEnr9091: 7709,
  BEnr2021: 406,
  TotalEnr2021: 10977,
  BEnr9091Perc: 0.05642755221170061,
  BEnr2021Perc: 0.03698642616379703,
  diff: '-1.94%',
  color: '#fab081',
  size: 6,
  center: [37.35701187756512, -120.52881507638506],
},
{
  District: 'Plainsburg Union Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.186922949296495, -120.34094632125735],
},
{
  District: 'Planada Elementary',
  County: 'Merced',
  BEnr9091: 2,
  TotalEnr9091: 797,
  BEnr2021: 13,
  TotalEnr2021: 838,
  BEnr9091Perc: 0.002509410288582183,
  BEnr2021Perc: 0.015513126491646777,
  diff: '1.3%',
  color: '#fab081',
  size: 6,
  center: [37.31821920099289, -120.27385913318881],
},
{
  District: 'Snelling-Merced Falls Union Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.51820977644499, -120.41127777538414],
},
{
  District: 'Weaver Union',
  County: 'Merced',
  BEnr9091: 84,
  TotalEnr9091: 1318,
  BEnr2021: 121,
  TotalEnr2021: 2960,
  BEnr9091Perc: 0.0637329286798179,
  BEnr2021Perc: 0.04087837837837838,
  diff: '-2.29%',
  color: '#fab081',
  size: 6,
  center: [37.26564374440421, -120.42340327877235],
},
{
  District: 'Winton',
  County: 'Merced',
  BEnr9091: 56,
  TotalEnr9091: 1478,
  BEnr2021: 14,
  TotalEnr2021: 1944,
  BEnr9091Perc: 0.037889039242219216,
  BEnr2021Perc: 0.00720164609053498,
  diff: '-3.07%',
  color: '#fab081',
  size: 6,
  center: [37.40352861320789, -120.61735876419557],
},
{
  District: 'Gustine Unified',
  County: 'Merced',
  BEnr9091: 12,
  TotalEnr9091: 1265,
  BEnr2021: 9,
  TotalEnr2021: 1765,
  BEnr9091Perc: 0.009486166007905139,
  BEnr2021Perc: 0.0050991501416430595,
  diff: '-0.44%',
  color: '#fab081',
  size: 6,
  center: [37.199311483590535, -121.01773737183736],
},
{
  District: 'Merced River Union Elementary',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.46290587605019, -120.51597176449769],
},
{
  District: 'Dos Palos Oro Loma Joint Unified',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.845369484984225, -120.68526754297372],
},
{
  District: 'Delhi Unified',
  County: 'Merced',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.42036082971473, -120.77404616240715],
},
{
  District: 'Calistoga Joint Unified',
  County: 'Napa',
  BEnr9091: 5,
  TotalEnr9091: 764,
  BEnr2021: 2,
  TotalEnr2021: 869,
  BEnr9091Perc: 0.006544502617801047,
  BEnr2021Perc: 0.0023014959723820483,
  diff: '-0.42%',
  color: '#fab081',
  size: 6,
  center: [38.61197090668361, -122.60450137160518],
},
{
  District: 'Howell Mountain Elementary',
  County: 'Napa',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.578814547548156, -122.44376642923166],
},
{
  District: 'Napa Valley Unified',
  County: 'Napa',
  BEnr9091: 121,
  TotalEnr9091: 13705,
  BEnr2021: 366,
  TotalEnr2021: 17240,
  BEnr9091Perc: 0.008828894564027728,
  BEnr2021Perc: 0.02122969837587007,
  diff: '1.24%',
  color: '#fab081',
  size: 6,
  center: [38.342925695584086, -122.27236197402964],
},
{
  District: 'Pope Valley Union Elementary',
  County: 'Napa',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.63542042692909, -122.41053541682335],
},
{
  District: 'Saint Helena Unified',
  County: 'Napa',
  BEnr9091: 5,
  TotalEnr9091: 1425,
  BEnr2021: 5,
  TotalEnr2021: 1187,
  BEnr9091Perc: 0.0035087719298245615,
  BEnr2021Perc: 0.004212299915754001,
  diff: '0.07%',
  color: '#fab081',
  size: 6,
  center: [38.60101176619538, -122.32773123973293],
},
{
  District: 'Arcohe Union Elementary',
  County: 'Sacramento',
  BEnr9091: 7,
  TotalEnr9091: 452,
  BEnr2021: 7,
  TotalEnr2021: 466,
  BEnr9091Perc: 0.015486725663716814,
  BEnr2021Perc: 0.015021459227467811,
  diff: '-0.05%',
  color: '#fab081',
  size: 6,
  center: [38.33501549039943, -121.17344676340255],
},
{
  District: 'Elk Grove Unified',
  County: 'Sacramento',
  BEnr9091: 3812,
  TotalEnr9091: 27246,
  BEnr2021: 6966,
  TotalEnr2021: 63947,
  BEnr9091Perc: 0.13991044556999194,
  BEnr2021Perc: 0.10893396093640045,
  diff: '-3.1%',
  color: '#fab081',
  size: 6,
  center: [38.43929371867981, -121.27712958479972],
},
{
  District: 'Elverta Joint Elementary',
  County: 'Sacramento',
  BEnr9091: 1,
  TotalEnr9091: 458,
  BEnr2021: 20,
  TotalEnr2021: 271,
  BEnr9091Perc: 0.002183406113537118,
  BEnr2021Perc: 0.07380073800738007,
  diff: '7.16%',
  color: '#fbc9a6',
  size: 6,
  center: [38.737658849344115, -121.48074109268714],
},
{
  District: 'Folsom-Cordova Unified',
  County: 'Sacramento',
  BEnr9091: 1213,
  TotalEnr9091: 12656,
  BEnr2021: 942,
  TotalEnr2021: 20096,
  BEnr9091Perc: 0.09584386852085967,
  BEnr2021Perc: 0.046875,
  diff: '-4.9%',
  color: '#fab081',
  size: 8,
  center: [38.61655935137541, -121.18235728794794],
},
{
  District: 'Galt Joint Union Elementary',
  County: 'Sacramento',
  BEnr9091: 12,
  TotalEnr9091: 1914,
  BEnr2021: 45,
  TotalEnr2021: 3332,
  BEnr9091Perc: 0.006269592476489028,
  BEnr2021Perc: 0.013505402160864346,
  diff: '0.72%',
  color: '#fab081',
  size: 6,
  center: [38.25511602438356, -121.31309879398503],
},
{
  District: 'Galt Joint Union High',
  County: 'Sacramento',
  BEnr9091: 5,
  TotalEnr9091: 1333,
  BEnr2021: 32,
  TotalEnr2021: 2209,
  BEnr9091Perc: 0.0037509377344336083,
  BEnr2021Perc: 0.014486192847442281,
  diff: '1.07%',
  color: '#fab081',
  size: 6,
  center: [38.28127759162201, -121.24181488742161],
},
{
  District: 'River Delta Joint Unified',
  County: 'Sacramento',
  BEnr9091: 20,
  TotalEnr9091: 2286,
  BEnr2021: 58,
  TotalEnr2021: 2279,
  BEnr9091Perc: 0.008748906386701663,
  BEnr2021Perc: 0.025449758666081616,
  diff: '1.67%',
  color: '#fbc9a6',
  size: 6,
  center: [38.21986776689426, -121.67418001254352],
},
{
  District: 'Robla Elementary',
  County: 'Sacramento',
  BEnr9091: 289,
  TotalEnr9091: 1668,
  BEnr2021: 320,
  TotalEnr2021: 2331,
  BEnr9091Perc: 0.17326139088729017,
  BEnr2021Perc: 0.13728013728013727,
  diff: '-3.6%',
  color: '#fab081',
  size: 6,
  center: [38.655106520937785, -121.44732216817195],
},
{
  District: 'Sacramento City Unified',
  County: 'Sacramento',
  BEnr9091: 10580,
  TotalEnr9091: 49557,
  BEnr2021: 6285,
  TotalEnr2021: 45078,
  BEnr9091Perc: 0.2134915350001009,
  BEnr2021Perc: 0.13942499667243444,
  diff: '-7.41%',
  color: '#fab081',
  size: 10,
  center: [38.52643544582717, -121.45278462212723],
},
{
  District: 'San Juan Unified',
  County: 'Sacramento',
  BEnr9091: 1942,
  TotalEnr9091: 47690,
  BEnr2021: 3555,
  TotalEnr2021: 50762,
  BEnr9091Perc: 0.040721325225414134,
  BEnr2021Perc: 0.07003270162720145,
  diff: '2.93%',
  color: '#fbc9a6',
  size: 6,
  center: [38.648433999286816, -121.30463535555856],
},
{
  District: 'Center Joint Unified',
  County: 'Sacramento',
  BEnr9091: 528,
  TotalEnr9091: 4214,
  BEnr2021: 483,
  TotalEnr2021: 4162,
  BEnr9091Perc: 0.12529663028001897,
  BEnr2021Perc: 0.11604997597308986,
  diff: '-0.92%',
  color: '#fab081',
  size: 6,
  center: [38.74130203167439, -121.40297314225889],
},
{
  District: 'Natomas Unified',
  County: 'Sacramento',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.664780149075916, -121.55805836748542],
},
{
  District: 'Twin Rivers Unified',
  County: 'Sacramento',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.68534780721068, -121.45226185505884],
},
{
  District: 'Bitterwater-Tully Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.36509574152149, -120.8739788227029],
},
{
  District: 'Cienega Union Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.71531092613601, -121.38792180520132],
},
{
  District: 'Hollister',
  County: 'San Benito',
  BEnr9091: 14,
  TotalEnr9091: 4052,
  BEnr2021: 28,
  TotalEnr2021: 5957,
  BEnr9091Perc: 0.0034550839091806516,
  BEnr2021Perc: 0.004700352526439483,
  diff: '0.12%',
  color: '#fab081',
  size: 6,
  center: [36.832377884718944, -121.39425753376496],
},
{
  District: 'Jefferson Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.509469420503734, -121.13329531476485],
},
{
  District: 'North County Joint Union Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.924398466899845, -121.36603679677948],
},
{
  District: 'Panoche Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.55503947003598, -120.82993594508174],
},
{
  District: 'San Benito High',
  County: 'San Benito',
  BEnr9091: 9,
  TotalEnr9091: 1901,
  BEnr2021: 18,
  TotalEnr2021: 3350,
  BEnr9091Perc: 0.004734350341925302,
  BEnr2021Perc: 0.005373134328358209,
  diff: '0.06%',
  color: '#fab081',
  size: 6,
  center: [36.65420704720896, -121.09661831473994],
},
{
  District: 'Southside Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.775571327306544, -121.34584204201303],
},
{
  District: 'Tres Pinos Union Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.792413984641975, -121.1711785308255],
},
{
  District: 'Willow Grove Union Elementary',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.65627158353353, -121.19562182396537],
},
{
  District: 'Aromas-San Juan Unified',
  County: 'San Benito',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [36.858907210271006, -121.55131819328034],
},
{
  District: 'San Francisco Unified',
  County: 'San Francisco',
  BEnr9091: 11320,
  TotalEnr9091: 61688,
  BEnr2021: 4351,
  TotalEnr2021: 58705,
  BEnr9091Perc: 0.18350408507327196,
  BEnr2021Perc: 0.07411634443403457,
  diff: '-10.94%',
  color: '#f6975f',
  size: 10,
  center: [37.756099573440466, -122.4411186858201],
},
{
  District: 'Banta Elementary',
  County: 'San Joaquin',
  BEnr9091: 6,
  TotalEnr9091: 280,
  BEnr2021: 116,
  TotalEnr2021: 1943,
  BEnr9091Perc: 0.02142857142857143,
  BEnr2021Perc: 0.05970149253731343,
  diff: '3.83%',
  color: '#fbc9a6',
  size: 6,
  center: [37.760255398118844, -121.34981672811837],
},
{
  District: 'Escalon Unified',
  County: 'San Joaquin',
  BEnr9091: 11,
  TotalEnr9091: 2416,
  BEnr2021: 17,
  TotalEnr2021: 2974,
  BEnr9091Perc: 0.004552980132450331,
  BEnr2021Perc: 0.0057162071284465365,
  diff: '0.12%',
  color: '#fab081',
  size: 6,
  center: [37.87760468391823, -121.02223327476328],
},
{
  District: 'Jefferson Elementary',
  County: 'San Joaquin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.615101681309994, -121.46110228394609],
},
{
  District: 'Lincoln Unified',
  County: 'San Joaquin',
  BEnr9091: 537,
  TotalEnr9091: 8247,
  BEnr2021: 1013,
  TotalEnr2021: 8939,
  BEnr9091Perc: 0.06511458712259004,
  BEnr2021Perc: 0.11332363799082672,
  diff: '4.82%',
  color: '#fbc9a6',
  size: 6,
  center: [37.99859361048069, -121.35806600273297],
},
{
  District: 'Linden Unified',
  County: 'San Joaquin',
  BEnr9091: 19,
  TotalEnr9091: 2017,
  BEnr2021: 9,
  TotalEnr2021: 2323,
  BEnr9091Perc: 0.009419930589985127,
  BEnr2021Perc: 0.0038743004735256135,
  diff: '-0.55%',
  color: '#fab081',
  size: 6,
  center: [38.04948430491138, -121.07164115977405],
},
{
  District: 'Lodi Unified',
  County: 'San Joaquin',
  BEnr9091: 1031,
  TotalEnr9091: 23954,
  BEnr2021: 2071,
  TotalEnr2021: 30738,
  BEnr9091Perc: 0.04304082825415379,
  BEnr2021Perc: 0.0673758865248227,
  diff: '2.43%',
  color: '#fbc9a6',
  size: 6,
  center: [38.12165611137124, -121.29965714847017],
},
{
  District: 'Manteca Unified',
  County: 'San Joaquin',
  BEnr9091: 295,
  TotalEnr9091: 13356,
  BEnr2021: 1403,
  TotalEnr2021: 23660,
  BEnr9091Perc: 0.02208745133273435,
  BEnr2021Perc: 0.05929839391377853,
  diff: '3.72%',
  color: '#fbc9a6',
  size: 6,
  center: [37.808867553833146, -121.24120711516096],
},
{
  District: 'New Hope Elementary',
  County: 'San Joaquin',
  BEnr9091: 1,
  TotalEnr9091: 199,
  BEnr2021: 1,
  TotalEnr2021: 177,
  BEnr9091Perc: 0.005025125628140704,
  BEnr2021Perc: 0.005649717514124294,
  diff: '0.06%',
  color: '#fab081',
  size: 6,
  center: [38.192532435533245, -121.4832496530321],
},
{
  District: 'New Jerusalem Elementary',
  County: 'San Joaquin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.6572222101455, -121.31660550426821],
},
{
  District: 'Oak View Union Elementary',
  County: 'San Joaquin',
  BEnr9091: 4,
  TotalEnr9091: 280,
  BEnr2021: 1,
  TotalEnr2021: 363,
  BEnr9091Perc: 0.014285714285714285,
  BEnr2021Perc: 0.0027548209366391185,
  diff: '-1.15%',
  color: '#fab081',
  size: 6,
  center: [38.24460232126335, -121.14339459094158],
},
{
  District: 'Ripon Unified',
  County: 'San Joaquin',
  BEnr9091: 11,
  TotalEnr9091: 2018,
  BEnr2021: 131,
  TotalEnr2021: 4728,
  BEnr9091Perc: 0.005450941526263627,
  BEnr2021Perc: 0.027707275803722505,
  diff: '2.23%',
  color: '#fbc9a6',
  size: 6,
  center: [37.77446078787496, -121.12525474825654],
},
{
  District: 'Stockton Unified',
  County: 'San Joaquin',
  BEnr9091: 4395,
  TotalEnr9091: 32687,
  BEnr2021: 4076,
  TotalEnr2021: 40627,
  BEnr9091Perc: 0.13445712362713005,
  BEnr2021Perc: 0.1003273684987816,
  diff: '-3.41%',
  color: '#fab081',
  size: 8,
  center: [37.95551974497769, -121.26888266264712],
},
{
  District: 'Tracy Joint Unified',
  County: 'San Joaquin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.76404542551698, -121.43625575854433],
},
{
  District: 'Lammersville Joint Unified',
  County: 'San Joaquin',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.74535279475577, -121.5577445063813],
},
{
  District: 'Bayshore Elementary',
  County: 'San Mateo',
  BEnr9091: 88,
  TotalEnr9091: 412,
  BEnr2021: 12,
  TotalEnr2021: 361,
  BEnr9091Perc: 0.21359223300970873,
  BEnr2021Perc: 0.0332409972299169,
  diff: '-18.04%',
  color: '#f3803f',
  size: 6,
  center: [37.70026983177081, -122.4053762282027],
},
{
  District: 'Belmont-Redwood Shores Elementary',
  County: 'San Mateo',
  BEnr9091: 67,
  TotalEnr9091: 1854,
  BEnr2021: 51,
  TotalEnr2021: 4152,
  BEnr9091Perc: 0.036138079827400214,
  BEnr2021Perc: 0.012283236994219654,
  diff: '-2.39%',
  color: '#fab081',
  size: 6,
  center: [37.519854211968, -122.27389056923087],
},
{
  District: 'Brisbane Elementary',
  County: 'San Mateo',
  BEnr9091: 20,
  TotalEnr9091: 494,
  BEnr2021: 7,
  TotalEnr2021: 474,
  BEnr9091Perc: 0.04048582995951417,
  BEnr2021Perc: 0.014767932489451477,
  diff: '-2.57%',
  color: '#fab081',
  size: 6,
  center: [37.687574435530145, -122.41570175247179],
},
{
  District: 'Burlingame Elementary',
  County: 'San Mateo',
  BEnr9091: 20,
  TotalEnr9091: 1867,
  BEnr2021: 11,
  TotalEnr2021: 3387,
  BEnr9091Perc: 0.010712372790573112,
  BEnr2021Perc: 0.003247711839385887,
  diff: '-0.75%',
  color: '#fab081',
  size: 6,
  center: [37.583418591902266, -122.37160458962407],
},
{
  District: 'Cabrillo Unified',
  County: 'San Mateo',
  BEnr9091: 12,
  TotalEnr9091: 3185,
  BEnr2021: 9,
  TotalEnr2021: 2934,
  BEnr9091Perc: 0.0037676609105180532,
  BEnr2021Perc: 0.003067484662576687,
  diff: '-0.07%',
  color: '#fab081',
  size: 6,
  center: [37.43320841554719, -122.39096960934901],
},
{
  District: 'Hillsborough City Elementary',
  County: 'San Mateo',
  BEnr9091: 8,
  TotalEnr9091: 1122,
  BEnr2021: 6,
  TotalEnr2021: 1268,
  BEnr9091Perc: 0.0071301247771836,
  BEnr2021Perc: 0.00473186119873817,
  diff: '-0.24%',
  color: '#fab081',
  size: 6,
  center: [37.55697586174407, -122.35825800146122],
},
{
  District: 'Jefferson Elementary',
  County: 'San Mateo',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.686326046755866, -122.46945720068594],
},
{
  District: 'Jefferson Union High',
  County: 'San Mateo',
  BEnr9091: 414,
  TotalEnr9091: 4479,
  BEnr2021: 61,
  TotalEnr2021: 4705,
  BEnr9091Perc: 0.09243134628265237,
  BEnr2021Perc: 0.012964930924548352,
  diff: '-7.95%',
  color: '#fab081',
  size: 8,
  center: [37.64771328506178, -122.46263389578242],
},
{
  District: 'Pacifica',
  County: 'San Mateo',
  BEnr9091: 289,
  TotalEnr9091: 4064,
  BEnr2021: 27,
  TotalEnr2021: 3006,
  BEnr9091Perc: 0.07111220472440945,
  BEnr2021Perc: 0.008982035928143712,
  diff: '-6.21%',
  color: '#fab081',
  size: 8,
  center: [37.60669068253484, -122.47935922528701],
},
{
  District: 'La Honda-Pescadero Unified',
  County: 'San Mateo',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.25153327548117, -122.2902094649011],
},
{
  District: 'Las Lomitas Elementary',
  County: 'San Mateo',
  BEnr9091: 15,
  TotalEnr9091: 732,
  BEnr2021: 10,
  TotalEnr2021: 1116,
  BEnr9091Perc: 0.020491803278688523,
  BEnr2021Perc: 0.008960573476702509,
  diff: '-1.15%',
  color: '#fab081',
  size: 6,
  center: [37.42053427072384, -122.21692055743807],
},
{
  District: 'Menlo Park City Elementary',
  County: 'San Mateo',
  BEnr9091: 108,
  TotalEnr9091: 1531,
  BEnr2021: 19,
  TotalEnr2021: 2781,
  BEnr9091Perc: 0.0705421293272371,
  BEnr2021Perc: 0.0068320747932398415,
  diff: '-6.37%',
  color: '#fab081',
  size: 6,
  center: [37.45589968645346, -122.18333671865754],
},
{
  District: 'Millbrae Elementary',
  County: 'San Mateo',
  BEnr9091: 55,
  TotalEnr9091: 2072,
  BEnr2021: 16,
  TotalEnr2021: 2238,
  BEnr9091Perc: 0.026544401544401543,
  BEnr2021Perc: 0.0071492403932082215,
  diff: '-1.94%',
  color: '#fab081',
  size: 6,
  center: [37.57823449922592, -122.4177315732704],
},
{
  District: 'Portola Valley Elementary',
  County: 'San Mateo',
  BEnr9091: 10,
  TotalEnr9091: 572,
  BEnr2021: 1,
  TotalEnr2021: 491,
  BEnr9091Perc: 0.017482517482517484,
  BEnr2021Perc: 0.002036659877800407,
  diff: '-1.54%',
  color: '#fab081',
  size: 6,
  center: [37.369378813937836, -122.2323642856139],
},
{
  District: 'Ravenswood City Elementary',
  County: 'San Mateo',
  BEnr9091: 1704,
  TotalEnr9091: 3982,
  BEnr2021: 159,
  TotalEnr2021: 2993,
  BEnr9091Perc: 0.42792566549472627,
  BEnr2021Perc: 0.05312395589709322,
  diff: '-37.48%',
  color: '#b5663b',
  size: 8,
  center: [37.48254082776572, -122.14727873768918],
},
{
  District: 'Redwood City Elementary',
  County: 'San Mateo',
  BEnr9091: 343,
  TotalEnr9091: 7861,
  BEnr2021: 86,
  TotalEnr2021: 8086,
  BEnr9091Perc: 0.04363312555654497,
  BEnr2021Perc: 0.010635666584219638,
  diff: '-3.3%',
  color: '#fab081',
  size: 8,
  center: [37.47770629918807, -122.24756480350078],
},
{
  District: 'San Bruno Park Elementary',
  County: 'San Mateo',
  BEnr9091: 55,
  TotalEnr9091: 2451,
  BEnr2021: 31,
  TotalEnr2021: 2275,
  BEnr9091Perc: 0.022439820481436147,
  BEnr2021Perc: 0.013626373626373627,
  diff: '-0.88%',
  color: '#fab081',
  size: 6,
  center: [37.62593449848131, -122.41906814264911],
},
{
  District: 'San Carlos Elementary',
  County: 'San Mateo',
  BEnr9091: 28,
  TotalEnr9091: 2039,
  BEnr2021: 19,
  TotalEnr2021: 3265,
  BEnr9091Perc: 0.01373222167729279,
  BEnr2021Perc: 0.005819295558958652,
  diff: '-0.79%',
  color: '#fab081',
  size: 6,
  center: [37.49974861102647, -122.26565735338556],
},
{
  District: 'San Mateo-Foster City',
  County: 'San Mateo',
  BEnr9091: 434,
  TotalEnr9091: 9139,
  BEnr2021: 80,
  TotalEnr2021: 10969,
  BEnr9091Perc: 0.04748878433088959,
  BEnr2021Perc: 0.007293281064819035,
  diff: '-4.02%',
  color: '#fab081',
  size: 8,
  center: [37.53367209060298, -122.32645328060416],
},
{
  District: 'San Mateo Union High',
  County: 'San Mateo',
  BEnr9091: 276,
  TotalEnr9091: 7731,
  BEnr2021: 77,
  TotalEnr2021: 9760,
  BEnr9091Perc: 0.03570042685292976,
  BEnr2021Perc: 0.007889344262295083,
  diff: '-2.78%',
  color: '#fab081',
  size: 8,
  center: [37.56127269665434, -122.36751270010872],
},
{
  District: 'Sequoia Union High',
  County: 'San Mateo',
  BEnr9091: 771,
  TotalEnr9091: 6288,
  BEnr2021: 253,
  TotalEnr2021: 10327,
  BEnr9091Perc: 0.1226145038167939,
  BEnr2021Perc: 0.024498886414253896,
  diff: '-9.81%',
  color: '#f6975f',
  size: 8,
  center: [37.451498940936446, -122.23769526801709],
},
{
  District: 'South San Francisco Unified',
  County: 'San Mateo',
  BEnr9091: 558,
  TotalEnr9091: 9512,
  BEnr2021: 89,
  TotalEnr2021: 8182,
  BEnr9091Perc: 0.05866274179983179,
  BEnr2021Perc: 0.010877536054754338,
  diff: '-4.78%',
  color: '#fab081',
  size: 8,
  center: [37.65480393842907, -122.4262844770805],
},
{
  District: 'Woodside Elementary',
  County: 'San Mateo',
  BEnr9091: 2,
  TotalEnr9091: 373,
  BEnr2021: 8,
  TotalEnr2021: 369,
  BEnr9091Perc: 0.005361930294906166,
  BEnr2021Perc: 0.02168021680216802,
  diff: '1.63%',
  color: '#fab081',
  size: 6,
  center: [37.42346383839268, -122.27933943798277],
},
{
  District: 'Alum Rock Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 849,
  TotalEnr9091: 16078,
  BEnr2021: 102,
  TotalEnr2021: 9850,
  BEnr9091Perc: 0.05280507525811668,
  BEnr2021Perc: 0.010355329949238578,
  diff: '-4.24%',
  color: '#fab081',
  size: 8,
  center: [37.35565563789528, -121.72934142938699],
},
{
  District: 'Berryessa Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 486,
  TotalEnr9091: 8405,
  BEnr2021: 80,
  TotalEnr2021: 6534,
  BEnr9091Perc: 0.0578227245687091,
  BEnr2021Perc: 0.012243648607284972,
  diff: '-4.56%',
  color: '#fab081',
  size: 8,
  center: [37.399280748159505, -121.84801423105529],
},
{
  District: 'Cambrian',
  County: 'Santa Clara',
  BEnr9091: 108,
  TotalEnr9091: 2507,
  BEnr2021: 69,
  TotalEnr2021: 3172,
  BEnr9091Perc: 0.0430793777423215,
  BEnr2021Perc: 0.021752837326607818,
  diff: '-2.13%',
  color: '#fab081',
  size: 6,
  center: [37.26889742851107, -121.93211269189504],
},
{
  District: 'Campbell Union',
  County: 'Santa Clara',
  BEnr9091: 364,
  TotalEnr9091: 6428,
  BEnr2021: 216,
  TotalEnr2021: 6622,
  BEnr9091Perc: 0.0566272557560672,
  BEnr2021Perc: 0.03261854424645122,
  diff: '-2.4%',
  color: '#fab081',
  size: 8,
  center: [37.28956830714722, -121.95589802917031],
},
{
  District: 'Campbell Union High',
  County: 'Santa Clara',
  BEnr9091: 236,
  TotalEnr9091: 5931,
  BEnr2021: 232,
  TotalEnr2021: 8606,
  BEnr9091Perc: 0.039790929017029165,
  BEnr2021Perc: 0.026957936323495236,
  diff: '-1.28%',
  color: '#fab081',
  size: 6,
  center: [37.2766990455845, -121.94753325465727],
},
{
  District: 'Cupertino Union',
  County: 'Santa Clara',
  BEnr9091: 233,
  TotalEnr9091: 12227,
  BEnr2021: 75,
  TotalEnr2021: 15663,
  BEnr9091Perc: 0.019056187126850414,
  BEnr2021Perc: 0.004788354721317755,
  diff: '-1.43%',
  color: '#fab081',
  size: 8,
  center: [37.31093738404142, -122.0737046155897],
},
{
  District: 'East Side Union High',
  County: 'Santa Clara',
  BEnr9091: 1553,
  TotalEnr9091: 21973,
  BEnr2021: 465,
  TotalEnr2021: 25946,
  BEnr9091Perc: 0.07067764984298912,
  BEnr2021Perc: 0.017921837662838204,
  diff: '-5.28%',
  color: '#fab081',
  size: 8,
  center: [37.32754634648515, -121.77552727172122],
},
{
  District: 'Evergreen Elementary',
  County: 'Santa Clara',
  BEnr9091: 778,
  TotalEnr9091: 9624,
  BEnr2021: 124,
  TotalEnr2021: 9789,
  BEnr9091Perc: 0.08083956774729842,
  BEnr2021Perc: 0.012667279599550515,
  diff: '-6.82%',
  color: '#fab081',
  size: 8,
  center: [37.29653616843561, -121.7570507241548],
},
{
  District: 'Franklin-McKinley Elementary',
  County: 'Santa Clara',
  BEnr9091: 611,
  TotalEnr9091: 9674,
  BEnr2021: 151,
  TotalEnr2021: 8980,
  BEnr9091Perc: 0.06315898284060369,
  BEnr2021Perc: 0.016815144766146994,
  diff: '-4.63%',
  color: '#fab081',
  size: 8,
  center: [37.30216373565357, -121.84536021721325],
},
{
  District: 'Fremont Union High',
  County: 'Santa Clara',
  BEnr9091: 235,
  TotalEnr9091: 7755,
  BEnr2021: 86,
  TotalEnr2021: 10836,
  BEnr9091Perc: 0.030303030303030304,
  BEnr2021Perc: 0.007936507936507936,
  diff: '-2.24%',
  color: '#fab081',
  size: 8,
  center: [37.33078847292577, -122.0614643748171],
},
{
  District: 'Gilroy Unified',
  County: 'Santa Clara',
  BEnr9091: 94,
  TotalEnr9091: 8511,
  BEnr2021: 155,
  TotalEnr2021: 11360,
  BEnr9091Perc: 0.011044530607449183,
  BEnr2021Perc: 0.013644366197183098,
  diff: '0.26%',
  color: '#fab081',
  size: 6,
  center: [37.03969713114337, -121.44991959646894],
},
{
  District: 'Lakeside Joint',
  County: 'Santa Clara',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.18852615540643, -122.05973473758122],
},
{
  District: 'Loma Prieta Joint Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 3,
  TotalEnr9091: 537,
  BEnr2021: 2,
  TotalEnr2021: 441,
  BEnr9091Perc: 0.00558659217877095,
  BEnr2021Perc: 0.0045351473922902496,
  diff: '-0.11%',
  color: '#fab081',
  size: 6,
  center: [37.122099011651265, -121.8882213372454],
},
{
  District: 'Los Altos Elementary',
  County: 'Santa Clara',
  BEnr9091: 49,
  TotalEnr9091: 2972,
  BEnr2021: 20,
  TotalEnr2021: 3576,
  BEnr9091Perc: 0.01648721399730821,
  BEnr2021Perc: 0.005592841163310962,
  diff: '-1.09%',
  color: '#fab081',
  size: 6,
  center: [37.35625053360094, -122.12988635152232],
},
{
  District: 'Los Gatos Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 21,
  TotalEnr9091: 2110,
  BEnr2021: 16,
  TotalEnr2021: 2710,
  BEnr9091Perc: 0.00995260663507109,
  BEnr2021Perc: 0.005904059040590406,
  diff: '-0.4%',
  color: '#fab081',
  size: 6,
  center: [37.19021933511256, -121.9466610459008],
},
{
  District: 'Los Gatos-Saratoga Union High',
  County: 'Santa Clara',
  BEnr9091: 14,
  TotalEnr9091: 2384,
  BEnr2021: 6,
  TotalEnr2021: 3470,
  BEnr9091Perc: 0.00587248322147651,
  BEnr2021Perc: 0.001729106628242075,
  diff: '-0.41%',
  color: '#fab081',
  size: 6,
  center: [37.18079092521861, -121.9736535354892],
},
{
  District: 'Luther Burbank',
  County: 'Santa Clara',
  BEnr9091: 6,
  TotalEnr9091: 304,
  BEnr2021: 12,
  TotalEnr2021: 475,
  BEnr9091Perc: 0.019736842105263157,
  BEnr2021Perc: 0.02526315789473684,
  diff: '0.55%',
  color: '#fab081',
  size: 6,
  center: [37.32280903957564, -121.92760968105677],
},
{
  District: 'Moreland',
  County: 'Santa Clara',
  BEnr9091: 184,
  TotalEnr9091: 3735,
  BEnr2021: 131,
  TotalEnr2021: 4364,
  BEnr9091Perc: 0.04926372155287818,
  BEnr2021Perc: 0.03001833180568286,
  diff: '-1.92%',
  color: '#fab081',
  size: 6,
  center: [37.296410421164126, -121.98055323084193],
},
{
  District: 'Morgan Hill Unified',
  County: 'Santa Clara',
  BEnr9091: 163,
  TotalEnr9091: 8702,
  BEnr2021: 123,
  TotalEnr2021: 8894,
  BEnr9091Perc: 0.018731326131923697,
  BEnr2021Perc: 0.013829548009894312,
  diff: '-0.49%',
  color: '#fab081',
  size: 6,
  center: [37.17591944325872, -121.61711809446439],
},
{
  District: 'Mountain View Whisman',
  County: 'Santa Clara',
  BEnr9091: 185,
  TotalEnr9091: 2833,
  BEnr2021: 60,
  TotalEnr2021: 4753,
  BEnr9091Perc: 0.06530180021178962,
  BEnr2021Perc: 0.012623606143488323,
  diff: '-5.27%',
  color: '#fab081',
  size: 8,
  center: [37.4190922432487, -122.07144343177036],
},
{
  District: 'Mountain View-Los Altos Union High',
  County: 'Santa Clara',
  BEnr9091: 176,
  TotalEnr9091: 2856,
  BEnr2021: 55,
  TotalEnr2021: 4563,
  BEnr9091Perc: 0.06162464985994398,
  BEnr2021Perc: 0.01205347359193513,
  diff: '-4.96%',
  color: '#fab081',
  size: 8,
  center: [37.38763104133267, -122.10070241452526],
},
{
  District: 'Mount Pleasant Elementary',
  County: 'Santa Clara',
  BEnr9091: 266,
  TotalEnr9091: 2649,
  BEnr2021: 32,
  TotalEnr2021: 1929,
  BEnr9091Perc: 0.1004152510381276,
  BEnr2021Perc: 0.01658890616899948,
  diff: '-8.38%',
  color: '#f6975f',
  size: 8,
  center: [37.35019219968827, -121.78395211016833],
},
{
  District: 'Oak Grove Elementary',
  County: 'Santa Clara',
  BEnr9091: 783,
  TotalEnr9091: 12044,
  BEnr2021: 273,
  TotalEnr2021: 9362,
  BEnr9091Perc: 0.06501162404516772,
  BEnr2021Perc: 0.029160435804315318,
  diff: '-3.59%',
  color: '#fab081',
  size: 8,
  center: [37.24794442647448, -121.7934127185745],
},
{
  District: 'Orchard Elementary',
  County: 'Santa Clara',
  BEnr9091: 9,
  TotalEnr9091: 392,
  BEnr2021: 40,
  TotalEnr2021: 815,
  BEnr9091Perc: 0.02295918367346939,
  BEnr2021Perc: 0.049079754601226995,
  diff: '2.61%',
  color: '#fbc9a6',
  size: 6,
  center: [37.383977169590516, -121.9087710324989],
},
{
  District: 'Palo Alto Unified',
  County: 'Santa Clara',
  BEnr9091: 398,
  TotalEnr9091: 7539,
  BEnr2021: 186,
  TotalEnr2021: 10754,
  BEnr9091Perc: 0.05279214749966839,
  BEnr2021Perc: 0.017295889901432025,
  diff: '-3.55%',
  color: '#fab081',
  size: 8,
  center: [37.411172404557725, -122.1510079530146],
},
{
  District: 'San Jose Unified',
  County: 'Santa Clara',
  BEnr9091: 1056,
  TotalEnr9091: 29630,
  BEnr2021: 721,
  TotalEnr2021: 28710,
  BEnr9091Perc: 0.03563955450556868,
  BEnr2021Perc: 0.02511320097526994,
  diff: '-1.05%',
  color: '#fab081',
  size: 8,
  center: [37.26355503845553, -121.86808284180564],
},
{
  District: 'Santa Clara Unified',
  County: 'Santa Clara',
  BEnr9091: 529,
  TotalEnr9091: 14043,
  BEnr2021: 374,
  TotalEnr2021: 14808,
  BEnr9091Perc: 0.03767001352987254,
  BEnr2021Perc: 0.025256618044300377,
  diff: '-1.24%',
  color: '#fab081',
  size: 8,
  center: [37.40312376336997, -121.97398179265655],
},
{
  District: 'Saratoga Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 10,
  TotalEnr9091: 1646,
  BEnr2021: 3,
  TotalEnr2021: 1657,
  BEnr9091Perc: 0.006075334143377886,
  BEnr2021Perc: 0.0018105009052504525,
  diff: '-0.43%',
  color: '#fab081',
  size: 6,
  center: [37.25070267624217, -122.05549148939548],
},
{
  District: 'Sunnyvale',
  County: 'Santa Clara',
  BEnr9091: 383,
  TotalEnr9091: 5639,
  BEnr2021: 79,
  TotalEnr2021: 5950,
  BEnr9091Perc: 0.0679198439439617,
  BEnr2021Perc: 0.013277310924369748,
  diff: '-5.46%',
  color: '#fab081',
  size: 8,
  center: [37.39016276777019, -122.02485400705064],
},
{
  District: 'Union Elementary',
  County: 'Santa Clara',
  BEnr9091: 120,
  TotalEnr9091: 4499,
  BEnr2021: 63,
  TotalEnr2021: 5727,
  BEnr9091Perc: 0.026672593909757725,
  BEnr2021Perc: 0.011000523834468309,
  diff: '-1.57%',
  color: '#fab081',
  size: 6,
  center: [37.24202436468928, -121.9174192502025],
},
{
  District: 'Milpitas Unified',
  County: 'Santa Clara',
  BEnr9091: 606,
  TotalEnr9091: 8452,
  BEnr2021: 180,
  TotalEnr2021: 10413,
  BEnr9091Perc: 0.07169900615238997,
  BEnr2021Perc: 0.01728608470181504,
  diff: '-5.44%',
  color: '#fab081',
  size: 8,
  center: [37.44689726457106, -121.71713090117349],
},
{
  District: 'Bonny Doon Union Elementary',
  County: 'Santa Cruz',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.06650826062168, -122.15083386547973],
},
{
  District: 'Happy Valley Elementary',
  County: 'Santa Cruz',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.04615729969044, -121.98137293227767],
},
{
  District: 'Live Oak',
  County: 'Santa Cruz',
  BEnr9091: 62,
  TotalEnr9091: 1868,
  BEnr2021: 38,
  TotalEnr2021: 1730,
  BEnr9091Perc: 0.033190578158458245,
  BEnr2021Perc: 0.021965317919075144,
  diff: '-1.12%',
  color: '#fab081',
  size: 6,
  center: [36.9709428478961, -121.98256084034641],
},
{
  District: 'Mountain Elementary',
  County: 'Santa Cruz',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.06046545029767, -121.9179643800642],
},
{
  District: 'Pacific Elementary',
  County: 'Santa Cruz',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.102938581973525, -122.24111049429418],
},
{
  District: 'Pajaro Valley Unified',
  County: 'Santa Cruz',
  BEnr9091: 75,
  TotalEnr9091: 16355,
  BEnr2021: 68,
  TotalEnr2021: 19276,
  BEnr9091Perc: 0.0045857535921736475,
  BEnr2021Perc: 0.0035277028429134675,
  diff: '-0.11%',
  color: '#fab081',
  size: 6,
  center: [36.95745905174417, -121.78742672729909],
},
{
  District: 'San Lorenzo Valley Unified',
  County: 'Santa Cruz',
  BEnr9091: 55,
  TotalEnr9091: 4223,
  BEnr2021: 32,
  TotalEnr2021: 5699,
  BEnr9091Perc: 0.01302391664693346,
  BEnr2021Perc: 0.0056150201789787685,
  diff: '-0.74%',
  color: '#fab081',
  size: 6,
  center: [37.13960146236933, -122.12819131412475],
},
{
  District: 'Santa Cruz City Elementary',
  County: 'Santa Cruz',
  BEnr9091: 152,
  TotalEnr9091: 3302,
  BEnr2021: 22,
  TotalEnr2021: 1684,
  BEnr9091Perc: 0.04603270745003028,
  BEnr2021Perc: 0.013064133016627079,
  diff: '-3.3%',
  color: '#fab081',
  size: 8,
  center: [36.990655524112476, -122.07113391272026],
},
{
  District: 'Santa Cruz City High',
  County: 'Santa Cruz',
  BEnr9091: 134,
  TotalEnr9091: 5212,
  BEnr2021: 90,
  TotalEnr2021: 4644,
  BEnr9091Perc: 0.025709900230237913,
  BEnr2021Perc: 0.01937984496124031,
  diff: '-0.63%',
  color: '#fab081',
  size: 6,
  center: [37.050014946647195, -122.10954795685956],
},
{
  District: 'Soquel Union Elementary',
  County: 'Santa Cruz',
  BEnr9091: 38,
  TotalEnr9091: 2291,
  BEnr2021: 14,
  TotalEnr2021: 1745,
  BEnr9091Perc: 0.016586643387167175,
  BEnr2021Perc: 0.008022922636103151,
  diff: '-0.86%',
  color: '#fab081',
  size: 6,
  center: [37.00444226056089, -121.95236583452686],
},
{
  District: 'Scotts Valley Unified',
  County: 'Santa Cruz',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.075944121695315, -122.00531003445995],
},
{
  District: 'Benicia Unified',
  County: 'Solano',
  BEnr9091: 268,
  TotalEnr9091: 4317,
  BEnr2021: 290,
  TotalEnr2021: 4526,
  BEnr9091Perc: 0.0620801482511003,
  BEnr2021Perc: 0.06407423773751657,
  diff: '0.2%',
  color: '#fab081',
  size: 6,
  center: [38.09368134502031, -122.13659984167245],
},
{
  District: 'Dixon Unified',
  County: 'Solano',
  BEnr9091: 55,
  TotalEnr9091: 3017,
  BEnr2021: 71,
  TotalEnr2021: 3407,
  BEnr9091Perc: 0.018230029830957905,
  BEnr2021Perc: 0.02083944819489287,
  diff: '0.26%',
  color: '#fab081',
  size: 6,
  center: [38.40726037497689, -121.79702725488917],
},
{
  District: 'Fairfield-Suisun Unified',
  County: 'Solano',
  BEnr9091: 3171,
  TotalEnr9091: 20227,
  BEnr2021: 2786,
  TotalEnr2021: 20703,
  BEnr9091Perc: 0.15677065308745736,
  BEnr2021Perc: 0.13456986910109647,
  diff: '-2.22%',
  color: '#fab081',
  size: 8,
  center: [38.205002921902526, -122.03891498549177],
},
{
  District: 'Travis Unified',
  County: 'Solano',
  BEnr9091: 612,
  TotalEnr9091: 3683,
  BEnr2021: 577,
  TotalEnr2021: 5284,
  BEnr9091Perc: 0.16616888406190605,
  BEnr2021Perc: 0.10919757759273278,
  diff: '-5.7%',
  color: '#fab081',
  size: 6,
  center: [38.2808717551937, -121.91798244468902],
},
{
  District: 'Vacaville Unified',
  County: 'Solano',
  BEnr9091: 814,
  TotalEnr9091: 12593,
  BEnr2021: 753,
  TotalEnr2021: 13025,
  BEnr9091Perc: 0.06463908520606686,
  BEnr2021Perc: 0.05781190019193858,
  diff: '-0.68%',
  color: '#fab081',
  size: 6,
  center: [38.386203613190965, -121.988747643992],
},
{
  District: 'Vallejo City Unified',
  County: 'Solano',
  BEnr9091: 5631,
  TotalEnr9091: 19049,
  BEnr2021: 3408,
  TotalEnr2021: 13252,
  BEnr9091Perc: 0.2956060685600294,
  BEnr2021Perc: 0.25716872924841533,
  diff: '-3.84%',
  color: '#fab081',
  size: 8,
  center: [38.121614281333315, -122.25446319041542],
},
{
  District: 'Alexander Valley Union Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.67236865085405, -122.75624810913895],
},
{
  District: 'West Sonoma County Union High',
  County: 'Sonoma',
  BEnr9091: 19,
  TotalEnr9091: 2043,
  BEnr2021: 31,
  TotalEnr2021: 1851,
  BEnr9091Perc: 0.00930004894762604,
  BEnr2021Perc: 0.016747703943814155,
  diff: '0.74%',
  color: '#fab081',
  size: 6,
  center: [38.48254485935184, -123.03711724523052],
},
{
  District: 'Bellevue Union',
  County: 'Sonoma',
  BEnr9091: 92,
  TotalEnr9091: 1328,
  BEnr2021: 18,
  TotalEnr2021: 1544,
  BEnr9091Perc: 0.06927710843373494,
  BEnr2021Perc: 0.011658031088082901,
  diff: '-5.76%',
  color: '#fab081',
  size: 6,
  center: [38.386073598290054, -122.70922803825361],
},
{
  District: 'Bennett Valley Union Elementary',
  County: 'Sonoma',
  BEnr9091: 6,
  TotalEnr9091: 983,
  BEnr2021: 18,
  TotalEnr2021: 989,
  BEnr9091Perc: 0.006103763987792472,
  BEnr2021Perc: 0.01820020222446916,
  diff: '1.21%',
  color: '#fab081',
  size: 6,
  center: [38.395250473949666, -122.63703386139169],
},
{
  District: 'Cinnabar Elementary',
  County: 'Sonoma',
  BEnr9091: 2,
  TotalEnr9091: 270,
  BEnr2021: 6,
  TotalEnr2021: 251,
  BEnr9091Perc: 0.007407407407407408,
  BEnr2021Perc: 0.02390438247011952,
  diff: '1.65%',
  color: '#fab081',
  size: 6,
  center: [38.25626485126788, -122.66541883967427],
},
{
  District: 'Cloverdale Unified',
  County: 'Sonoma',
  BEnr9091: 8,
  TotalEnr9091: 1372,
  BEnr2021: 3,
  TotalEnr2021: 1350,
  BEnr9091Perc: 0.0058309037900874635,
  BEnr2021Perc: 0.0022222222222222222,
  diff: '-0.36%',
  color: '#fab081',
  size: 6,
  center: [38.788673458566386, -123.03034617098135],
},
{
  District: 'Dunham Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.31569280748975, -122.75745792860924],
},
{
  District: 'Forestville Union Elementary',
  County: 'Sonoma',
  BEnr9091: 11,
  TotalEnr9091: 803,
  BEnr2021: 1,
  TotalEnr2021: 267,
  BEnr9091Perc: 0.0136986301369863,
  BEnr2021Perc: 0.003745318352059925,
  diff: '-1.0%',
  color: '#fab081',
  size: 6,
  center: [38.48427663940306, -122.91399930835674],
},
{
  District: 'Fort Ross Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.56800632002192, -123.24368294982285],
},
{
  District: 'Geyserville Unified',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.720624499549, -122.97400427056321],
},
{
  District: 'Gravenstein Union Elementary',
  County: 'Sonoma',
  BEnr9091: 9,
  TotalEnr9091: 727,
  BEnr2021: 5,
  TotalEnr2021: 757,
  BEnr9091Perc: 0.012379642365887207,
  BEnr2021Perc: 0.0066050198150594455,
  diff: '-0.58%',
  color: '#fab081',
  size: 6,
  center: [38.360399305215616, -122.78421668391748],
},
{
  District: 'Guerneville Elementary',
  County: 'Sonoma',
  BEnr9091: 11,
  TotalEnr9091: 627,
  BEnr2021: 22,
  TotalEnr2021: 460,
  BEnr9091Perc: 0.017543859649122806,
  BEnr2021Perc: 0.04782608695652174,
  diff: '3.03%',
  color: '#fbc9a6',
  size: 6,
  center: [38.53139946486865, -123.00119448208811],
},
{
  District: 'Harmony Union Elementary',
  County: 'Sonoma',
  BEnr9091: 8,
  TotalEnr9091: 614,
  BEnr2021: 9,
  TotalEnr2021: 617,
  BEnr9091Perc: 0.013029315960912053,
  BEnr2021Perc: 0.014586709886547812,
  diff: '0.16%',
  color: '#fab081',
  size: 6,
  center: [38.38704146603493, -122.96791300253058],
},
{
  District: 'Horicon Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.71189218703023, -123.3253795941366],
},
{
  District: 'Kenwood',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.4311421031911, -122.5454770789761],
},
{
  District: 'Liberty Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.28274587067623, -122.70972473152595],
},
{
  District: 'Mark West Union Elementary',
  County: 'Sonoma',
  BEnr9091: 26,
  TotalEnr9091: 1219,
  BEnr2021: 8,
  TotalEnr2021: 1298,
  BEnr9091Perc: 0.02132895816242822,
  BEnr2021Perc: 0.0061633281972265025,
  diff: '-1.52%',
  color: '#fab081',
  size: 6,
  center: [38.520495549623114, -122.7447542088372],
},
{
  District: 'Monte Rio Union Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.456490332572294, -123.06765276446482],
},
{
  District: 'Montgomery Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.5461672180398, -123.10976702152186],
},
{
  District: 'Oak Grove Union Elementary',
  County: 'Sonoma',
  BEnr9091: 7,
  TotalEnr9091: 497,
  BEnr2021: 17,
  TotalEnr2021: 1293,
  BEnr9091Perc: 0.014084507042253521,
  BEnr2021Perc: 0.013147718484145398,
  diff: '-0.09%',
  color: '#fab081',
  size: 6,
  center: [38.44112049920783, -122.85456441347755],
},
{
  District: 'Old Adobe Union',
  County: 'Sonoma',
  BEnr9091: 35,
  TotalEnr9091: 2185,
  BEnr2021: 27,
  TotalEnr2021: 2058,
  BEnr9091Perc: 0.016018306636155607,
  BEnr2021Perc: 0.013119533527696793,
  diff: '-0.29%',
  color: '#fab081',
  size: 6,
  center: [38.21792123009327, -122.53125386480491],
},
{
  District: 'Petaluma City Elementary',
  County: 'Sonoma',
  BEnr9091: 28,
  TotalEnr9091: 2404,
  BEnr2021: 22,
  TotalEnr2021: 2424,
  BEnr9091Perc: 0.011647254575707155,
  BEnr2021Perc: 0.009075907590759076,
  diff: '-0.26%',
  color: '#fab081',
  size: 6,
  center: [38.25898306174545, -122.62533960398468],
},
{
  District: 'Petaluma Joint Union High',
  County: 'Sonoma',
  BEnr9091: 43,
  TotalEnr9091: 3941,
  BEnr2021: 71,
  TotalEnr2021: 5233,
  BEnr9091Perc: 0.01091093631058107,
  BEnr2021Perc: 0.013567743168354672,
  diff: '0.27%',
  color: '#fab081',
  size: 6,
  center: [38.22161251508866, -122.65420862427662],
},
{
  District: 'Piner-Olivet Union Elementary',
  County: 'Sonoma',
  BEnr9091: 20,
  TotalEnr9091: 1259,
  BEnr2021: 32,
  TotalEnr2021: 1240,
  BEnr9091Perc: 0.015885623510722795,
  BEnr2021Perc: 0.025806451612903226,
  diff: '0.99%',
  color: '#fab081',
  size: 6,
  center: [38.47323622479989, -122.8011367948061],
},
{
  District: 'Kashia Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.65660263870501, -123.3390203908138],
},
{
  District: 'Rincon Valley Union Elementary',
  County: 'Sonoma',
  BEnr9091: 65,
  TotalEnr9091: 2771,
  BEnr2021: 87,
  TotalEnr2021: 3096,
  BEnr9091Perc: 0.023457235654998194,
  BEnr2021Perc: 0.02810077519379845,
  diff: '0.46%',
  color: '#fab081',
  size: 6,
  center: [38.49025024410487, -122.62686043823527],
},
{
  District: 'Roseland',
  County: 'Sonoma',
  BEnr9091: 54,
  TotalEnr9091: 915,
  BEnr2021: 18,
  TotalEnr2021: 2873,
  BEnr9091Perc: 0.05901639344262295,
  BEnr2021Perc: 0.006265227984684998,
  diff: '-5.28%',
  color: '#fab081',
  size: 6,
  center: [38.42614726660741, -122.73191893161209],
},
{
  District: 'Santa Rosa Elementary',
  County: 'Sonoma',
  BEnr9091: 193,
  TotalEnr9091: 4851,
  BEnr2021: 81,
  TotalEnr2021: 4651,
  BEnr9091Perc: 0.03978561121418264,
  BEnr2021Perc: 0.017415609546334122,
  diff: '-2.24%',
  color: '#fab081',
  size: 8,
  center: [38.4565521957159, -122.71900394930529],
},
{
  District: 'Santa Rosa High',
  County: 'Sonoma',
  BEnr9091: 241,
  TotalEnr9091: 9895,
  BEnr2021: 205,
  TotalEnr2021: 10821,
  BEnr9091Perc: 0.024355735219807984,
  BEnr2021Perc: 0.018944644672396267,
  diff: '-0.54%',
  color: '#fab081',
  size: 6,
  center: [38.4588240333824, -122.66787639125315],
},
{
  District: 'Sebastopol Union Elementary',
  County: 'Sonoma',
  BEnr9091: 3,
  TotalEnr9091: 1340,
  BEnr2021: 9,
  TotalEnr2021: 817,
  BEnr9091Perc: 0.002238805970149254,
  BEnr2021Perc: 0.011015911872705019,
  diff: '0.88%',
  color: '#fab081',
  size: 6,
  center: [38.4089319251634, -122.83482486614528],
},
{
  District: 'Sonoma Valley Unified',
  County: 'Sonoma',
  BEnr9091: 40,
  TotalEnr9091: 4631,
  BEnr2021: 19,
  TotalEnr2021: 3950,
  BEnr9091Perc: 0.008637443316778234,
  BEnr2021Perc: 0.004810126582278481,
  diff: '-0.38%',
  color: '#fab081',
  size: 6,
  center: [38.29058197245253, -122.46902589335437],
},
{
  District: 'Twin Hills Union Elementary',
  County: 'Sonoma',
  BEnr9091: 15,
  TotalEnr9091: 838,
  BEnr2021: 3,
  TotalEnr2021: 1101,
  BEnr9091Perc: 0.017899761336515514,
  BEnr2021Perc: 0.0027247956403269754,
  diff: '-1.52%',
  color: '#fab081',
  size: 6,
  center: [38.364782254243686, -122.84839065963168],
},
{
  District: 'Two Rock Union',
  County: 'Sonoma',
  BEnr9091: 4,
  TotalEnr9091: 199,
  BEnr2021: 2,
  TotalEnr2021: 123,
  BEnr9091Perc: 0.020100502512562814,
  BEnr2021Perc: 0.016260162601626018,
  diff: '-0.38%',
  color: '#fab081',
  size: 6,
  center: [38.26542783455794, -122.77250662358425],
},
{
  District: 'Waugh Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.28847133283465, -122.63657431607727],
},
{
  District: 'West Side Union Elementary',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.59160669259925, -122.97809481939194],
},
{
  District: 'Wilmar Union Elementary',
  County: 'Sonoma',
  BEnr9091: 3,
  TotalEnr9091: 222,
  BEnr2021: 3,
  TotalEnr2021: 217,
  BEnr9091Perc: 0.013513513513513514,
  BEnr2021Perc: 0.013824884792626729,
  diff: '0.03%',
  color: '#fab081',
  size: 6,
  center: [38.229090497860916, -122.69034703061486],
},
{
  District: 'Wright Elementary',
  County: 'Sonoma',
  BEnr9091: 67,
  TotalEnr9091: 1189,
  BEnr2021: 36,
  TotalEnr2021: 1308,
  BEnr9091Perc: 0.056349873843566024,
  BEnr2021Perc: 0.027522935779816515,
  diff: '-2.88%',
  color: '#fab081',
  size: 6,
  center: [38.42223018878086, -122.76301983523955],
},
{
  District: 'Cotati-Rohnert Park Unified',
  County: 'Sonoma',
  BEnr9091: 248,
  TotalEnr9091: 7280,
  BEnr2021: 109,
  TotalEnr2021: 6111,
  BEnr9091Perc: 0.03406593406593406,
  BEnr2021Perc: 0.017836687939780722,
  diff: '-1.62%',
  color: '#fab081',
  size: 8,
  center: [38.3391689328915, -122.70601922965055],
},
{
  District: 'Windsor Unified',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.54884821654816, -122.79845517637006],
},
{
  District: 'Healdsburg Unified',
  County: 'Sonoma',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.63138662506624, -122.87865322542645],
},
{
  District: 'Ceres Unified',
  County: 'Stanislaus',
  BEnr9091: 142,
  TotalEnr9091: 7466,
  BEnr2021: 242,
  TotalEnr2021: 14667,
  BEnr9091Perc: 0.019019555317439058,
  BEnr2021Perc: 0.016499625008522534,
  diff: '-0.25%',
  color: '#fab081',
  size: 6,
  center: [37.56433975038018, -121.03007046874586],
},
{
  District: 'Chatom Union',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.47406681025948, -120.96358277784148],
},
{
  District: 'Denair Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.54672105902031, -120.70716439459922],
},
{
  District: 'Empire Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 111,
  TotalEnr9091: 3451,
  BEnr2021: 108,
  TotalEnr2021: 2866,
  BEnr9091Perc: 0.032164589973920604,
  BEnr2021Perc: 0.03768318213538032,
  diff: '0.55%',
  color: '#fab081',
  size: 6,
  center: [37.643021455472244, -120.8728592520993],
},
{
  District: 'Gratton Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.57296828771724, -120.78755696735924],
},
{
  District: 'Hart-Ransom Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 10,
  TotalEnr9091: 564,
  BEnr2021: 16,
  TotalEnr2021: 1208,
  BEnr9091Perc: 0.01773049645390071,
  BEnr2021Perc: 0.013245033112582781,
  diff: '-0.45%',
  color: '#fab081',
  size: 6,
  center: [37.6589021011807, -121.13411186997025],
},
{
  District: 'Hickman Community Charter',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.61008981253108, -120.73378283523935],
},
{
  District: 'Keyes Union',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.54772120244248, -120.90670336426685],
},
{
  District: 'Knights Ferry Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.796161794154244, -120.65857972695433],
},
{
  District: 'Modesto City Elementary',
  County: 'Stanislaus',
  BEnr9091: 592,
  TotalEnr9091: 17405,
  BEnr2021: 353,
  TotalEnr2021: 15275,
  BEnr9091Perc: 0.03401321459350761,
  BEnr2021Perc: 0.023109656301145663,
  diff: '-1.09%',
  color: '#fab081',
  size: 8,
  center: [37.62952033876113, -121.0048832968361],
},
{
  District: 'Modesto City High',
  County: 'Stanislaus',
  BEnr9091: 302,
  TotalEnr9091: 10697,
  BEnr2021: 438,
  TotalEnr2021: 15957,
  BEnr9091Perc: 0.028232214639618586,
  BEnr2021Perc: 0.027448768565519834,
  diff: '-0.08%',
  color: '#fab081',
  size: 6,
  center: [37.66267271718337, -121.03389322450123],
},
{
  District: 'Paradise Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.621132468370966, -121.06026989578176],
},
{
  District: 'Patterson Joint Unified',
  County: 'Stanislaus',
  BEnr9091: 41,
  TotalEnr9091: 3267,
  BEnr2021: 287,
  TotalEnr2021: 6012,
  BEnr9091Perc: 0.012549739822467095,
  BEnr2021Perc: 0.04773785761809714,
  diff: '3.52%',
  color: '#fbc9a6',
  size: 6,
  center: [37.45615279271281, -121.35706726778231],
},
{
  District: 'Roberts Ferry Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.63671548439814, -120.55402380459772],
},
{
  District: 'Salida Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 58,
  TotalEnr9091: 1619,
  BEnr2021: 88,
  TotalEnr2021: 3059,
  BEnr9091Perc: 0.035824583075972825,
  BEnr2021Perc: 0.02876757110166721,
  diff: '-0.71%',
  color: '#fab081',
  size: 6,
  center: [37.701509889902205, -121.12072703742044],
},
{
  District: 'Shiloh Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.61693475541659, -121.1242270586532],
},
{
  District: 'Stanislaus Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 151,
  TotalEnr9091: 3553,
  BEnr2021: 157,
  TotalEnr2021: 3431,
  BEnr9091Perc: 0.04249929636926541,
  BEnr2021Perc: 0.04575925386184786,
  diff: '0.33%',
  color: '#fab081',
  size: 6,
  center: [37.718347703300125, -121.02301521727681],
},
{
  District: 'Sylvan Union Elementary',
  County: 'Stanislaus',
  BEnr9091: 225,
  TotalEnr9091: 6117,
  BEnr2021: 264,
  TotalEnr2021: 7913,
  BEnr9091Perc: 0.03678273663560569,
  BEnr2021Perc: 0.033362820674838874,
  diff: '-0.34%',
  color: '#fab081',
  size: 6,
  center: [37.69675207368298, -120.95790453339981],
},
{
  District: 'Valley Home Joint Elementary',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.918239543477654, -120.86949209350239],
},
{
  District: 'Newman-Crows Landing Unified',
  County: 'Stanislaus',
  BEnr9091: 7,
  TotalEnr9091: 1530,
  BEnr2021: 52,
  TotalEnr2021: 3213,
  BEnr9091Perc: 0.004575163398692811,
  BEnr2021Perc: 0.016184251478369126,
  diff: '1.16%',
  color: '#fab081',
  size: 6,
  center: [37.30745223521111, -121.22226074737156],
},
{
  District: 'Hughson Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.62174459820777, -120.64029184990933],
},
{
  District: 'Riverbank Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.70184701303634, -120.88687726142336],
},
{
  District: 'Oakdale Joint Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.82014241048131, -120.77298524451201],
},
{
  District: 'Waterford Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.66160778336106, -120.73721256785228],
},
{
  District: 'Turlock Unified',
  County: 'Stanislaus',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [37.48532776437188, -120.91515348600781],
},
{
  District: 'Davis Joint Unified',
  County: 'Yolo',
  BEnr9091: 217,
  TotalEnr9091: 6110,
  BEnr2021: 241,
  TotalEnr2021: 8229,
  BEnr9091Perc: 0.03551554828150573,
  BEnr2021Perc: 0.02928666909709564,
  diff: '-0.62%',
  color: '#fab081',
  size: 6,
  center: [38.49821648974093, -121.69328227220642],
},
{
  District: 'Esparto Unified',
  County: 'Yolo',
  BEnr9091: 18,
  TotalEnr9091: 775,
  BEnr2021: 28,
  TotalEnr2021: 934,
  BEnr9091Perc: 0.023225806451612905,
  BEnr2021Perc: 0.029978586723768737,
  diff: '0.68%',
  color: '#fab081',
  size: 6,
  center: [38.78094208588707, -122.12011104892404],
},
{
  District: 'Washington Unified',
  County: 'Yolo',
  BEnr9091: 'Not available',
  TotalEnr9091: 'Not available',
  BEnr2021: 'Not available',
  TotalEnr2021: 'Not available',
  BEnr9091Perc: 'Not available',
  BEnr2021Perc: 'Not available',
  diff: 'Not available',
  color: '#D3D3D3',
  size: 4,
  center: [38.55964789890238, -121.56082665682905],
},
{
  District: 'Winters Joint Unified',
  County: 'Yolo',
  BEnr9091: 8,
  TotalEnr9091: 1640,
  BEnr2021: 30,
  TotalEnr2021: 2148,
  BEnr9091Perc: 0.004878048780487805,
  BEnr2021Perc: 0.013966480446927373,
  diff: '0.91%',
  color: '#fab081',
  size: 6,
  center: [38.5459167704692, -122.01325865812592],
},
{
  District: 'Woodland Joint Unified',
  County: 'Yolo',
  BEnr9091: 124,
  TotalEnr9091: 8476,
  BEnr2021: 125,
  TotalEnr2021: 9658,
  BEnr9091Perc: 0.0146295422369042,
  BEnr2021Perc: 0.012942638227376268,
  diff: '-0.17%',
  color: '#fab081',
  size: 6,
  center: [38.72138223746934, -121.77016062288146],
}],
  minLat: 37.8503526,
  maxLat: 37.899434,
  minLong: -122.3256618,
  maxLong: -122.2319033,
};
export default districtData;
